import { gql } from "@apollo/client";

const STUDENT_REGISTRATION = gql`
  mutation StudentRegistration(
    $email: String!
    $password: String!
    $givenName: String!
    $familyName: String!
    $currentLevelId: ID!
    $sendTips: Boolean
    $spokenOnly: Boolean
    $locale: String
    $charactersPreference: String
    $timeZone: String
    $adInfo: String
    $urlRegister: String
    $registrationSurveyId: ID
    $role: Int
    $ref: String
  ) {
    studentRegistration(
      email: $email
      password: $password
      givenName: $givenName
      familyName: $familyName
      currentLevelId: $currentLevelId
      sendTips: $sendTips
      spokenOnly: $spokenOnly
      locale: $locale
      charactersPreference: $charactersPreference
      timeZone: $timeZone
      adInfo: $adInfo
      urlRegister: $urlRegister
      registrationSurveyId: $registrationSurveyId
      role: $role
      ref: $ref
    ) {
      credentials {
        uid
        accessToken
        client
      }
      authenticatable {
        givenName
        familyName
        locale
        email
      }
    }
  }
`;

export default STUDENT_REGISTRATION;
